import { useFlightContext } from "../../hooks/useFlightContext";
import { useStyles } from "./AllPrompts.web.styles";

export const useColumnStyle = () => {
  const styles = useStyles();
  const { isFlightActive } = useFlightContext();

  const cardColStyles = isFlightActive("isGoBoldPromptCardEnabled")
    ? styles.cardColV2
    : isFlightActive("isResponsiveDimensionsEnabled")
      ? styles.cardColResponsive
      : styles.cardCol;

  return cardColStyles;
};
